import React from 'react';
import cn from 'classnames';
import { formatDate } from '../../../../common/utils/format';

const DiscountVouchersDialogWrapper = ({ visible, close, children }) => {
  return (
    <div
      className={cn('moodboard-modal', 'moodboard-customers-orders-modal', {
        '-open': visible,
      })}
    >
      <div className="moodboard-modal_backdrop" onClick={() => close()} />
      <div className="moodboard-modal_dialog">
        <button className="moodboard-modal_close" onClick={() => close()} />
        {children}
      </div>
    </div>
  );
};

const DiscountVouchersDialogInner = ({ discountVouchers, visible, loading }) => {
  if (!visible) return null;

  if (loading) {
    return <div className={cn('discount-vouchers', '-loading')}>Loading...</div>;
  } else if (!loading && (!discountVouchers || discountVouchers.length === 0)) {
    return (
      <div className={cn('discount-vouchers', '-empty')}>
        The customer has no shopping credits
      </div>
    );
  } else {
    // Determine background colors for groups of vouchers if needed, similar to slim template
    // For now simple table
    return (
      <div className="discount-vouchers">
        <h3>Shopping Credits</h3>
        <table>
          <thead>
            <tr>
              <th>Amount</th>
              <th>Valid From</th>
              <th>Valid Until</th>
              <th>Date Used</th>
              <th>Order</th>
              <th>Min Spend</th>
            </tr>
          </thead>
          <tbody>
            {discountVouchers.map((voucher) => (
              <tr key={voucher.id}>
                <td>£{voucher.amount}</td>
                <td>{formatDate(new Date(voucher.valid_from), 'd MMM yy')}</td>
                <td>{formatDate(new Date(voucher.valid_until), 'd MMM yy')}</td>
                <td>{voucher.utilized_at ? formatDate(new Date(voucher.utilized_at), 'd MMM yy') : '-'}</td>
                <td>
                  {voucher.order_link ? (
                    <span>
                      Order #{voucher.order_link.number} ({formatDate(new Date(voucher.order_link.date), 'd MMM yy')})
                    </span>
                  ) : (
                    '-'
                  )}
                </td>
                <td>{voucher.minimum_spend > 0 ? `£${voucher.minimum_spend}` : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
};

const DiscountVouchersDialog = ({ visible, close, discountVouchers, loading }) => (
  <DiscountVouchersDialogWrapper visible={visible} close={close}>
    <DiscountVouchersDialogInner discountVouchers={discountVouchers} visible={visible} loading={loading} />
  </DiscountVouchersDialogWrapper>
);

export default DiscountVouchersDialog;



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Moodboard/components/DiscountVouchersDialog.js